import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import About from '../components/About';

const AboutPage = () => {
  return (
    <div className="min-h-screen flex flex-col bg-brand-black">
      <Header />
      <main className="flex-grow pt-20">
        <About />
      </main>
      <Footer />
    </div>
  );
};

export default AboutPage;